.Main {
    display: grid;
    justify-content: center;
    align-content: center;
    height: 100%;
    opacity: 0;
    overflow: hidden;
    will-change: opacity;
}

.Inner {
    position: relative;
    transform-origin: 50% 50%;
    transform: rotate(90deg);

}

.Border {
    position: absolute;
    top: 2%;
    left: 1%;
    right: 1%;
    bottom: 2%;
}

.Title {
    display: block;
    position: relative;
    font-size: 30vh;
    height: auto;
    font-weight: normal;
    margin: 0;
    line-height: 0.8;
    letter-spacing: -0.03em;
    padding: 0.0375em 0.1em 0.0075em 0.225em;
    font-variation-settings: "wght" 400;
}

@media (orientation: landscape) {
    .Inner {
        transform: none
    }

    .Title {
        font-size: 40vw;
    }
}
